import { defineStore } from 'pinia';
import { ref } from 'vue';
import { apolloClient } from '@/apollo';
import { MY_WAREHOUSE_ASSIGNMENT_QUERY } from '@/graphql/queries';

export const useWarehouseAssignmentStore = defineStore(
  'warehouse_assignment',
  () => {
    const loaded = ref(false);
    const enforceQuickLabeling = ref(false);
    const warehouseId = ref<string | null>(null);

    async function fetch() {
      const { data } = await apolloClient.query({
        query: MY_WAREHOUSE_ASSIGNMENT_QUERY,
        fetchPolicy: 'network-only',
      });
      const row = data?.eatfresh_warehouse_assignment?.[0];
      enforceQuickLabeling.value = row?.enforce_quick_labeling ?? false;
      warehouseId.value = row?.warehouse_id ?? null;
      loaded.value = true;
    }

    function $reset() {
      loaded.value = false;
      enforceQuickLabeling.value = false;
      warehouseId.value = null;
    }

    return {
      loaded,
      enforceQuickLabeling,
      warehouseId,
      fetch,
      $reset,
    };
  },
);
